import { IPrepaidProgramFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidProgram/PrepaidProgramMeta';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
type Props = {
    meta: IPrepaidProgramFormMeta,
    register: any,
    errors: any,
    isLoading: any,
    data: any, 
    columns: any,
};

export default React.forwardRef(function MiscellaneousPeriodicFeesTabPanelFormUI ({  meta, register, errors, isLoading, data, columns }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  return (
    <CC.Box>
      <CustomReactTable
        data={data}
        columns={columns}
      />
    </CC.Box>
  );
});

